import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import BlogCard from './BlogCard';
import { getAllBlogs } from '../utils/blogLoader';

const BlogsPage: React.FC = () => {
  const blogs = getAllBlogs();
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-8 pb-16">
      <button 
        onClick={() => navigate('/')}
        className="flex items-center gap-2 text-dev-text-muted hover:text-dev-text transition-colors mb-4"
      >
        <ArrowLeft size={20} />
        <span>Back</span>
      </button>
      <h1 className="text-3xl font-medium mb-8 text-dev-text">All Blog Posts</h1>
      <div className="space-y-6">
        {blogs.map(blog => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>
    </div>
  );
};

export default BlogsPage; 